export default __webpack_public_path__ + "static/media/le_lion12.8370174b.jpg";